import { takeEvery, call, put } from 'redux-saga/effects';
import {
  insertUpdateItems,
  dataRequest,
  requestInProgress,
  requestFinished
} from '../../../../../../common/reducers/listsCollection/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import LocaleService from '../../../../services/LocaleService';

function* dataRequestSaga(reducerName, action) {
  try {
    yield put(requestInProgress(reducerName, action.payload.regionCode));
    const result = yield call(
      timeoutCall,
      LocaleService.getCities,
      action.payload.countryCode,
      action.payload.regionCode
    );
    if (result.response) {
      // status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateItems(reducerName, {
            itemsById: result.destructData.items,
            groupMapItemsIds: result.destructData.mapItems
          })
        );
      }
    }
    yield put(requestFinished(reducerName, action.payload.regionCode));
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(dataRequest(reducerName).type, dataRequestSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/reducers/static/collections/sagas/citiesCollectionSaga.js